import { IOnInit, IWindowService } from "angular";
import { ColDef } from "../../../../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../../../records/grids/columns/columnDefinitionService";
import { IRowCommandEventArgs } from "../../../../../../records/grids/controller";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../../../records/server/query";
import { MachineConfigurationGateway } from "../../../../models/machineConfiguration";
import { ProgressiveDefinition } from "../../../../models/progressiveDefinition";
import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../../../records/views/recordGridView";
import { vsObjectName as machineConfigurationName } from "../../../../config/machineConfiguration";
import { RecordDataSource } from "../../../../../../records/grids";
import {
  MachineConfigurationCellClassService,
  vsServiceName as MachineConfigurationCellClassServiceName,
} from "../../../../../shared/machineConfigurationCellClassService";
import {
  AuthorizedUiElementConfig,
  AuthorizedUiElementService,
} from "../../../../../../ui/authorizedUiElement";
import { vsServiceName as MachineDetailTabsServiceName } from "../../../../../shared/components/views/machines/detail/tabs";

export const ProgressiveDetailMachinesComponentControllerGridId = Symbol(
  "main.machines.progressives.detail.machines"
);

export class ProgressivesDetailMachinesComponentController implements IOnInit {
  static $inject = [
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    RecordGridViewServiceName,
    MachineDetailTabsServiceName,
    MachineConfigurationCellClassServiceName,
  ];

  defaultQuery: IQuery = {};
  readonly progressiveDefinition!: ProgressiveDefinition;
  readonly gridSettings: IGridSettings;

  readonly gridDataSource: RecordDataSource;
  readonly defaultSort: string;
  readonly columns: ColDef[];

  constructor(
    gridSettingsService: GridSettingsService,
    private readonly columnDefinitionService: ColumnDefinitionService,
    recordGridViewService: RecordGridViewService,
    private readonly machineDetailTabsService: AuthorizedUiElementService<AuthorizedUiElementConfig>,
    private readonly machineConfigurationCellClassService: MachineConfigurationCellClassService
  ) {
    const gridConfiguration = recordGridViewService.getGridConfiguration(
      machineConfigurationName
    )!;
    this.gridDataSource = gridConfiguration.gridDataSource!;
    this.columns = this.getColumns(gridConfiguration);
    this.defaultSort = gridConfiguration.defaultSort!;

    this.gridSettings = gridSettingsService.getGridSettings(
      ProgressiveDetailMachinesComponentControllerGridId
    );
  }

  getColumns(gridConfiguration: GridConfiguration): ColDef[] {
    const firstMachineDetailTab =
      this.machineDetailTabsService.getSrefByIndex(0);

    const columns = [
      this.columnDefinitionService.getLinkColDef({
        headerName: "detail",
        iconClass: "fa fa-info-circle text-primary",
        colId: "detail",
        stateExpression: `${firstMachineDetailTab}({machineId: data.MachineId})`,
      }),
      ...(gridConfiguration?.columns ?? []),
    ];

    this.machineConfigurationCellClassService.styleColumns(columns, true);

    return columns;
  }

  $onInit() {
    this.defaultQuery = {
      ProgressiveDefinitionId: this.progressiveDefinition.Id,
      CurrentConfiguration: true,
    };
  }

  currentConfigurationChanged(currentConfigurationsOnly: boolean) {
    if (!currentConfigurationsOnly) {
      this.defaultQuery.CurrentConfiguration = undefined;
    }
  }
}
